import * as React from 'react';

import { connect } from 'react-redux';
import AppState from '@webapp/store/state';

import styled from 'styled-components';

import SidebarCtrl, { SidebarSection } from '@webapp/controllers/sidebar';
import { Translate } from 'react-localize-redux';
import { LabelFeatureFlags } from '@common/types/record-label/record-label';


export const labelProfileMenuSections = ({
  deals,
}: LabelFeatureFlags): SidebarSection[] => {
  const sections = [
    {
      path: '/label/general',
      label: <Translate id="DASHBOARD.NEW_DASHBOARD.LABEL.MENU.SETTINGS" />,
      noIcon: true,
    },
    {
      path: '/label/team',
      label: <Translate id="DASHBOARD.NEW_DASHBOARD.LABEL.MENU.TEAM" />,
      noIcon: true,
    },
    {
      path: '/label/roster',
      label: <Translate id="DASHBOARD.NEW_DASHBOARD.LABEL.MENU.ROSTER" />,
      noIcon: true,
    }
  ];

  if (deals) {
    sections.push({
      path: '/label/deals',
      label: <Translate id="DASHBOARD.NEW_DASHBOARD.LABEL.MENU.DEALS" />,
      noIcon: true,
    });
  }

  return sections;
};

interface LabelProfileSidebarCtrlProps {
  className?: string;
  isMobile: boolean;
  dealsEnabled: boolean;
}

const mapStateToProps = (state: AppState) => ({
  isMobile: state.ui.mobile,
  dealsEnabled: !!state.recordLabels.active?.flags?.deals,
});

export const LabelProfileSidebarCtrl: React.FC<
  LabelProfileSidebarCtrlProps
> = ({ className, dealsEnabled }) => {
  const options = React.useMemo(
    () => labelProfileMenuSections({ deals: dealsEnabled }),
    [dealsEnabled]
  );

  return (
    <div className={className}>
      <SidebarCtrl
        title={<Translate id="LABEL_PROFILE.SIDEBAR.TITLE" />}
        sections={options}
      />
    </div>
  );
};

export default connect(mapStateToProps)(styled(LabelProfileSidebarCtrl)``);
